import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { headers, GET_HOTEL_ENQUIRY_LIST, getHotelEnquiryListUrl } from "../../../utils/constants";


export const getHotelEnquiryList_action = (exhNo, CompanyName) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhRegistrationNo: exhNo,
            CompanyName: CompanyName,
        }
        console.log("sessionStorage.getItem('ExhRegistrationIDSS')", sessionStorage.getItem('ExhRegistrationIDSS'))

        const res = await axiosGet(getHotelEnquiryListUrl, params, headers)

        dispatch({
            type: GET_HOTEL_ENQUIRY_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}